export const MAX_BET_LIMIT = 25
